module.exports = __webpack_public_path__ + "static/media/NotoSans-Bold.98f0cacc.ttf";